import api from '@/api/notifications';

export default {
    state: {
        notifications: [],
    },
    getters: {},
    mutations: {
        SET_NOTIFICATIONS_DATA(state, payload) {
            state.notifications = payload;
        },
    },
    actions: {
        fetchNotifications({
            commit
        }) {
            api.get().then(({
                data: {
                    data: {
                        notifications
                    }
                },
                status
            }) => {
                if (status === 200) {
                    commit('SET_NOTIFICATIONS_DATA', notifications);
                }
            });
        },
        async deleteNotification({
            dispatch
        }, payload) {
            dispatch('setIsLoadingData', true);
            try {
                const result = await api.delete(payload);
                return Promise.resolve(result.data.data);
            } catch (e) {
                const {
                    response: {
                        data: {
                            data: {
                                messages
                            }
                        }
                    }
                } = e;

                return Promise.reject(messages);
            } finally {
                dispatch('setIsLoadingData', false);
            }
        },
        async deleteAllNotifications({
            dispatch
        }) {
            dispatch('setIsLoadingData', true);
            try {
                const result = await api.deleteAll();
                return Promise.resolve(result.data.data);
            } catch (e) {
                const {
                    response: {
                        data: {
                            data: {
                                messages
                            }
                        }
                    }
                } = e;

                return Promise.reject(messages);
            } finally {
                dispatch('setIsLoadingData', false);
            }
        },
    },
};